var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinbaseWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{fill:#1652F0;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Guides",
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 512,
    cy: 512,
    r: 512
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M559.2,672c26.2,0,52.4-5.8,75.6-14.5l49.4,75.6c-43.6,23.3-90.2,34.9-139.6,34.9 c-148.3,0-258.9-98.9-258.9-256c2.9-157.1,116.4-256,261.8-256c52.4,0,90.2,11.6,130.9,32l-46.5,78.5 c-23.3-8.7-49.4-14.5-75.6-14.5c-87.3,0-157.1,55.3-157.1,160C399.2,610.9,466.1,672,559.2,672z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinbaseWalletIcon);
export default __webpack_public_path__ + "static/media/coinbaseWalletIcon.bd3a0164899aed9a123bbd136fd00233.svg";
export { ForwardRef as ReactComponent };